import React from 'react'
import {useField} from 'formik'
import {Check} from 'react-bootstrap-icons'

import styles from './RadioField.module.scss'

interface Props extends React.InputHTMLAttributes<HTMLInputElement>{
  name: string
  label: React.ReactNode
  description?: React.ReactNode
}

export default function RadioField({
  label,
  description,
  className,
  type,
  ...props
}: Props) {
  const [field] = useField({name: props.name, type: 'radio', value: props.value})

  return (
    <div className={className}>
      <label className={`${styles.RadioLabel} d-block`}>
        <input type="radio" className={`${styles.RadioField}`} {...field} {...props} />

        <div className={`${styles.RadioBlock} p-3 bg-white border border-grey rounded d-flex align-items-center justify-content-between`}>
          <div className="d-flex align-items-center">
            <div className={`${styles.RadioMark} mr-3`}>
              <Check size={24} color="white" />
            </div>
            <div>{label}</div>
          </div>
          {!!description && (
            <div className="text-muted text-right pl-3">{description}</div>
          )}
        </div>
      </label>
    </div>
  )
}
